
import React, {useRef, useEffect} from 'react'
import { Container, Tab, Form, Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import "./SearchBox.css"
import SearchRealStates from '../SearchRealStates/SearchRealStates';
import SearchResidence from '../SearchResidence/SearchResidence';


const SearchBox = () => {
    const { t } = useTranslation();
    const activeTab = useSelector((state) => state.main.activeTab);
    const fixed = useSelector((state)=>state.main.fixed)
    const showSearchBox = useSelector((state)=>state.main.showSearchBox)

      
    return  <>
              {
                fixed && showSearchBox ? <Container >
              {
                activeTab == "SearchRealState" ? <SearchRealStates /> : activeTab == "SearchResidence" ? <SearchResidence /> : null
              }
            </Container> : fixed && !showSearchBox ? null :
              <Container >
                {
                  activeTab == "SearchRealState" ? <SearchRealStates/> : activeTab == "SearchResidence" ? <SearchResidence /> : null
                }
              </Container>
              }
            </>
            
}
export default SearchBox